// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }

  SITE.trackSection = function() {
    // Check, if the section is provided in the markup.
    var sectionPage = parseInt($('body').attr('data-section'));

    // console.log(sectionPage);

    // Check, if a cookie the section cookie is set.
    var sectionCookie = Cookies.get('STYXKEY_sobrato_section');
    // console.log(sectionCookie);

    if (typeof sectionCookie == 'undefined') {
      // console.log('create the cookie');
      Cookies.set('STYXKEY_sobrato_section', sectionPage);
    }
    else {
      // Check, if there is a change.
      if (sectionPage !== parseInt(sectionCookie)) {
        Cookies.set('STYXKEY_sobrato_section', sectionPage);
      }
    }
  }


})();


// Invocations

$(function () {


  SITE.trackSection();

});
